// extracted by mini-css-extract-plugin
var _1 = "Buttons-modulebuttons__W_rkc";
var _2 = "Buttons-moduleconfirm__YvLHY";
var _3 = "Buttons-modulesSize__bsFMc";
export { _1 as "buttons", _2 as "confirm", _3 as "sSize" }
